import { ComponentProps } from 'react'

import Image from 'next/image'

import { getPlaceholderShimmer } from 'lib/utils/images'

import Box from 'components/atomic/atoms/box'

const getTitle = () => {
  if (window === undefined) {
    return 'Image'
  }

  return window.document.title
}

const SharedImg = (props: Omit<ComponentProps<typeof Image>, 'ref'>) => {
  const { width = 720, height = 380, alt = getTitle(), ...rest } = props

  return (
    <Box
      as={Image}
      alt={alt}
      width={width}
      height={height}
      placeholder="blur"
      blurDataURL={getPlaceholderShimmer(width, height)}
      quality="100"
      css={{ borderRadius: '$md', objectFit: 'cover' }}
      {...rest}
    />
  )
}

export default SharedImg
